import { ReactNode } from 'react'

import { Typography } from '@/components/ui/typography'

import * as S from './tab-card.styled'

interface TabCardProps {
  actions?: ReactNode
  children: ReactNode
  fill?: boolean
  title?: string
  titleSuffix?: ReactNode
}

export const TabCard = ({ actions, children, fill, title, titleSuffix }: TabCardProps) => (
  <S.Card $fill={fill}>
    <S.Header $sticky={!fill}>
      {(title || titleSuffix) && (
        <S.TitleGroup>
          {title && (
            <Typography size="heading-small" as="h2" color="black800">
              {title}
            </Typography>
          )}
          {titleSuffix}
        </S.TitleGroup>
      )}
      {actions && <S.Actions>{actions}</S.Actions>}
    </S.Header>
    {children}
  </S.Card>
)
